<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
  import {ref, onBeforeMount, onUnmounted} from 'vue';
  import {getComponentConfig} from '@core/utils/getComponentConfig';

  interface Props {
    class?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    class: '',
  });

  const defaultConfig = {
    base: 'divide-y divide-gray-100 dark:divide-gray-800',
  };

  const config = ref(defaultConfig);

  let configLoadCancelled = false;
  onUnmounted(() => {
    configLoadCancelled = true;
  });

  onBeforeMount(async () => {
    try {
      const next = await getComponentConfig('List', defaultConfig);
      if (!configLoadCancelled) {
        config.value = next;
      }
    } catch {
      if (!configLoadCancelled) {
        config.value = defaultConfig;
      }
    }
  });
</script>

<template>
  <div :class="['list', config.base, props.class]">
    <slot />
  </div>
</template>
